import { render, staticRenderFns } from "./JustSold.vue?vue&type=template&id=f97330cc&"
import script from "./JustSold.vue?vue&type=script&lang=js&"
export * from "./JustSold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports